enum CommonText {
    notApplicable = '--',
}

export { CommonText };
